// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expired-link p{font-size:30px}.expired-link p:last-child{font-size:20px}\n", "",{"version":3,"sources":["webpack://./src/components/pages/ExpiredLink.scss"],"names":[],"mappings":"AAAA,gBAEI,cAAe,CAFnB,2BAMI,cAAe","sourcesContent":[".expired-link {\n  p {\n    font-size: 30px;\n  }\n\n  p:last-child {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
